const hiddenTranslationsByConversation = new Map();

const getSetForConversation = conversationId => {
  if (!conversationId) return new Set();
  if (!hiddenTranslationsByConversation.has(conversationId)) {
    hiddenTranslationsByConversation.set(conversationId, new Set());
  }
  return hiddenTranslationsByConversation.get(conversationId);
};

export const isTranslationHiddenForMessage = (conversationId, messageId) => {
  const hiddenSet = getSetForConversation(conversationId);
  return hiddenSet.has(messageId);
};

export const toggleTranslationHiddenForMessage = (
  conversationId,
  messageId
) => {
  const hiddenSet = getSetForConversation(conversationId);
  if (hiddenSet.has(messageId)) {
    hiddenSet.delete(messageId);
    return false;
  }
  hiddenSet.add(messageId);
  return true;
};

export const clearAllTranslationHiddenState = () => {
  hiddenTranslationsByConversation.clear();
};
